<template>
    <div class="min-h-screen flex flex-col bg-white">
        <Topbar :appName="`${appName} | Blog`" />

        <main class="flex-1">
            <slot />
        </main>

        <Footer
            :appName="appName"
            :openCookieSettingsElementId="openCookieSettingsElementId"
        />
    </div>
</template>

<script setup lang="ts">
    import Topbar from '@/Marketing/LandingPage/Component/LandingPage/Topbar.vue'
    import Footer from '@/Marketing/LandingPage/Component/LandingPage/Footer.vue'

    defineProps({
        appName: {
            type: String,
            required: true,
        },
        openCookieSettingsElementId: {
            type: String,
            required: true,
        },
    })
</script>
